/*
 * Painted illustrations dropped into src/images/royal-mahal (see the README there).
 * Every image in the folder is picked up automatically; a missing one returns null
 * so the caller can fall back to the code-drawn art.
 */
const context = require.context("../../../images/royal-mahal", true, /\.(webp|jpe?g|png)$/i);

const PAINTINGS = Object.fromEntries(
  context.keys().map((key) => [key.replace(/^\.\//, "").replace(/\.(webp|jpe?g|png)$/i, ""), context(key)]),
);

export const painting = (name) => PAINTINGS[name] || null;

// Event names are free text, so match on common words (Hindi and English).
const EVENT_TYPES = [
  ["haldi", /haldi|pithi|tel ?baan|mayra|mayara/],
  ["mehendi", /mehe?n?di|mehndi|henna/],
  ["sangeet", /sangeet|garba|dandiya|music|dance/],
  ["engagement", /engage|ring|sagai|roka|mangni|tilak|sagan/],
  ["reception", /reception/],
  ["wedding", /wedding|vivah|vivaah|shaadi|shadi|phere|pheras|lagna|lagan|nikah|anand karaj|varmala|jaimala/],
  ["puja", /puja|pooja|havan|path\b|chowki|ganesh|mata/],
  ["party", /cocktail|party|night/],
  ["feast", /dinner|lunch|brunch|bhoj|feast|breakfast/],
];

export const eventType = (name = "") => {
  const text = name.toLowerCase();
  const match = EVENT_TYPES.find(([, pattern]) => pattern.test(text));
  return match ? match[0] : "celebration";
};

export const eventPainting = (name) => painting(`events/${eventType(name)}`) || painting("events/celebration");
